"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DeckCardContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var MILLISECONDS_BEFORE_CHECK_LOAD = 2500;
var DeckCardContext = exports.DeckCardContext = /*#__PURE__*/_react["default"].createContext();
var VideoPlayerWrapper = function VideoPlayerWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loading", _descriptor, _this);
      _initializerDefineProperty(_this, "initialPlayFinished", _descriptor2, _this);
      _initializerDefineProperty(_this, "errorLoading", _descriptor3, _this);
      _initializerDefineProperty(_this, "playing", _descriptor4, _this);
      _initializerDefineProperty(_this, "isNative", _descriptor5, _this);
      _initializerDefineProperty(_this, "videoLoaded", _descriptor6, _this);
      _initializerDefineProperty(_this, "playAfterError", _descriptor7, _this);
      _initializerDefineProperty(_this, "canPlay", _descriptor8, _this);
      _initializerDefineProperty(_this, "unmounted", _descriptor9, _this);
      _initializerDefineProperty(_this, "initialTimestamp", _descriptor0, _this);
      _initializerDefineProperty(_this, "readyTimestamp", _descriptor1, _this);
      _initializerDefineProperty(_this, "readyForDisplay", _descriptor10, _this);
      _this.setUpNativePlayer = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(video) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // mobile only
                _this.isNative = true;
                if (video && !_this.video) {
                  _this.video = video;
                  //clearTimeout(this.timeout);
                  _this.initializeCheckIfLoaded();
                  _this.logEvent('set-up-native-player');
                  if (_this.props.delayLoad) {
                    setTimeout(_this.loadVideo, 200);
                    _this.logEvent('delay-load-video');
                  } else {
                    _this.loadVideo();
                  }
                }
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      _this.onReadyForDisplay = function () {
        // mobile only
        _this.readyTimestamp = new Date().getTime();
        _this.readyForDisplay = true;
        var loadTime = _this.readyTimestamp - _this.initialTimestamp;
        _this.logEvent('on-ready-for-display', "loadTime: ".concat(loadTime));
      };
      _this.showErrorIfNotLoaded = function () {
        _this.logEvent('check-show-error-if-not-loaded');
        if (!_this.readyForDisplay) {
          _this.logEvent('video-not-loaded-show-error');
          _this.initialTimestamp = null;
          _this.reloadVideoAfterError();
          // this.errorLoading = true;
        }
      };
      _this.onCanPlay = function () {
        _this.logEvent('on-can-play');
        _this.canPlay = true;
        if ((_this.props.autoPlay || _this.playAfterError) && (!_this.initialPlayFinished && !_this.playing || _this.props.forcePlay)) {
          _this.play();
        } else {
          _this.loading = false;
        }
      };
      _this.onEndPlayback = function () {
        // web only or mobile inline
        if (_this.props.loop) {
          return;
        }
        if (_this.props.afterVideoPlayback) {
          _this.props.afterVideoPlayback(_this.props.card, _this.props.cardState);
        }
        if (!_this.initialPlayFinished && _this.props.afterInitialPlay) {
          _this.props.afterInitialPlay(_this.props.card, _this.props.cardState);
        }
        _this.initialPlayFinished = true;
        _this.pause();
      };
      _this.unloadVideo = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this.logEvent('unload-video');
              if (!_this.video) {
                _context2.n = 4;
                break;
              }
              _context2.p = 1;
              _context2.n = 2;
              return _this.video.unloadAsync();
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              _this.logEvent('unload-video-error');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      _this.logEvent = function (event, value) {
        // console.log('log event', event, value, this.props.videoClip.id, this.props.cardState)
      };
      _this.loadVideo = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var videoClip;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this.logEvent('load-video');
              _this.readyForDisplay = false;
              _this.loading = true;
              _this.canPlay = false;
              _this.initialPlayFinished = false;
              // this.unloadVideo();
              videoClip = _this.props.videoClip.localAsset ? _this.props.videoClip.mp4Url : {
                uri: _this.props.videoClip.mp4Url
              };
              _context3.n = 1;
              return _this.video.loadAsync(videoClip, {}, false);
            case 1:
              _this.timeout = setTimeout(_this.checkLoadStatus, MILLISECONDS_BEFORE_CHECK_LOAD);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      _this.reloadVideoAfterError = function () {
        _this.logEvent('reload-video-after-error');
        _this.readyForDisplay = false;
        _this.video = null;
        _this.unmounted = true;
        setTimeout(function () {
          return _this.unmounted = false;
        }, 200);
        _this.initializeCheckIfLoaded();
        _this.errorLoading = false;
        _this.playAfterError = true;
      };
      _this.initializeCheckIfLoaded = function () {
        _this.logEvent('initialize-check-if-loaded');
        _this.initialTimestamp = new Date().getTime();
        if (_state.AppUI.siteIsSeedlang) {
          setTimeout(function () {
            return _this.showErrorIfNotLoaded();
          }, 4000);
        }
      };
      _this.onPlaybackStatusUpdate = function (status) {
        // mobile only
        if (!_this.videoLoaded) {
          _this.logEvent('on-playback-status-update');
        }
        if (!status.error && status.isLoaded !== false) {
          if (!_this.videoLoaded) {
            _this.logEvent('on-playback-status-update-loaded');
          }
          clearTimeout(_this.timeout);
          _this.videoLoaded = true;
          _this.errorLoading = false;
          if (!_this.props.loop && status.didJustFinish) {
            if (_this.props.afterVideoPlayback) {
              _this.props.afterVideoPlayback(_this.props.card, _this.props.cardState);
            }
            if (!_this.initialPlayFinished && _this.props.afterInitialPlay) {
              _this.props.afterInitialPlay(_this.props.card, _this.props.cardState);
            }
            _this.initialPlayFinished = true;
            _this.pause();
          }
        }
      };
      _this.checkLoadStatus = function () {
        _this.logEvent('check-load-status');
        _this.loading = false;
        if (!_this.videoLoaded) {
          _this.logEvent('check-load-status-error');
          _this.errorLoading = true;
        }
      };
      _this.onError = function () {
        if (_this.playing) {
          _this.pause();
        }
      };
      _this.pause = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this.playing = false;
              if (!_this.video) {
                _context4.n = 1;
                break;
              }
              _context4.n = 1;
              return _this.video.pauseAsync();
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      _this.play = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(_this.errorLoading || !_this.canPlay)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              if (!_this.video) {
                _context5.n = 4;
                break;
              }
              if (_this.playing) {
                _context5.n = 2;
                break;
              }
              _context5.n = 2;
              return _this.video.setPositionAsync(0);
            case 2:
              _context5.n = 3;
              return _this.video.setIsLoopingAsync(_this.props.loop);
            case 3:
              _context5.n = 4;
              return _this.video.playAsync();
            case 4:
              _this.loading = false;
              _this.playing = true;
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t2 = _context5.v;
              _this.logEvent('play-error', _t2.message || 'Unknown error playing video');
            case 6:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 5]]);
      }));
      _this.onTogglePlay = function () {
        if (_this.playing) {
          _this.pause();
        } else {
          _this.play();
        }
      };
      if (props.autoPlay) {
        _this.play();
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$context;
        this.deckCardInView = (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.inView;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$context2;
        if (!prevProps.autoPlay && this.props.autoPlay && !this.playing || this.props.autoPlay && this.props.autoPlayTimestamp !== prevProps.autoPlayTimestamp) {
          this.play();
        } else if (prevProps.videoClip && this.props.videoClip && prevProps.videoClip.mp4Url !== this.props.videoClip.mp4Url) {
          this.loading = true;
          this.logEvent('component-did-update');
          if (this.isNative && !this.props.delayLoad) {
            this.loadVideo();
          } else if (this.isNative && this.props.delayLoad) {
            this.logEvent('delay-load-video');
            setTimeout(this.loadVideo, 400);
          }
        }
        var deckCardInView = (_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.inView;
        if (this.deckCardInView && deckCardInView === false) {
          this.pause();
        }
        this.deckCardInView = deckCardInView;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unloadVideo();
        this.video = null;
      }
    }, {
      key: "hasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.props.videoClip);
      }
    }, {
      key: "hideIcon",
      get: function get() {
        return this.props.hideIcon || !this.hasVideoClip && !this.props.objectUrl;
      }
    }, {
      key: "showSpinnerIcon",
      get: function get() {
        return !this.props.usingDataSaverHeader && this.loading;
      }
    }, {
      key: "showRefreshIcon",
      get: function get() {
        return !this.hideIcon && !this.showSpinnerIcon && this.status === 'ended';
      }
    }, {
      key: "showPlayIcon",
      get: function get() {
        return !this.hideIcon && !this.showSpinnerIcon && !this.showRefreshIcon && this.status !== 'playing' && this.status !== 'ended';
      }
    }, {
      key: "src",
      get: function get() {
        if (this.props.useWebm && this.props.videoClip) {
          return this.props.videoClip.webmUrl;
        }
        if (this.props.videoClip) {
          return this.props.videoClip.mp4Url;
        }
        return this.props.objectUrl;
      }
    }, {
      key: "status",
      get: function get() {
        if (this.loading) {
          return 'loading';
        }
        if (this.playing) {
          return 'playing';
        }
        if (this.initialPlayFinished) {
          return 'ended';
        }
        return 'paused';
      }
    }, {
      key: "render",
      value: function render() {
        var _this$context$cardOnS, _this$context3, _this$context4;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          hasVideoClip: this.hasVideoClip,
          hideIcon: this.hideIcon,
          showSpinnerIcon: this.showSpinnerIcon,
          showRefreshIcon: this.showRefreshIcon,
          showPlayIcon: this.showPlayIcon,
          src: this.src,
          status: this.status,
          onCanPlay: this.onCanPlay,
          onEndPlayback: this.onEndPlayback,
          onError: this.onError,
          errorLoading: this.errorLoading,
          onTogglePlay: this.onTogglePlay,
          pause: this.pause,
          playing: this.playing,
          inDeckCardView: (_this$context$cardOnS = (_this$context3 = this.context) === null || _this$context3 === void 0 ? void 0 : _this$context3.cardOnScreen) !== null && _this$context$cardOnS !== void 0 ? _this$context$cardOnS : (_this$context4 = this.context) === null || _this$context4 === void 0 ? void 0 : _this$context4.inView,
          setUpNativePlayer: this.setUpNativePlayer,
          onPlaybackStatusUpdate: this.onPlaybackStatusUpdate,
          play: this.play,
          playNative: this.playNative,
          reloadVideoAfterError: this.reloadVideoAfterError,
          isNative: this.isNative,
          loading: this.loading,
          unmounted: this.unmounted,
          onReadyForDisplay: this.onReadyForDisplay
        }));
      }
    }]);
  }(_react["default"].Component), _Class.contextType = DeckCardContext, _Class), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialPlayFinished", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "errorLoading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "playing", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isNative", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "videoLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "playAfterError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "canPlay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "unmounted", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "initialTimestamp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "readyTimestamp", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "readyForDisplay", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hideIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinnerIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinnerIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showRefreshIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showRefreshIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPlayIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPlayIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "src", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "src"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "status", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "status"), _class2.prototype), _class2)) || _class;
};
VideoPlayerWrapper.displayName = 'VideoPlayerWrapper';
var _default = exports["default"] = VideoPlayerWrapper;